<div class="epics-page">
  <div class="page-header">
    <div>
      <h1>Epics</h1>
      <p class="muted">Track epic progress across a project</p>
    </div>
    <mat-form-field appearance="outline" class="project-filter">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="projectId" (selectionChange)="loadEpics()">
        @for (p of projects(); track p.id) {
          <mat-option [value]="p.id">{{ p.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (error()) {
    <div class="error-banner">{{ error() }}</div>
  }

  @if (loading()) {
    <div class="loading-center"><mat-spinner diameter="40"></mat-spinner></div>
  } @else {
    <div class="epic-grid">
      @for (epic of epics(); track epic.epicId) {
        <mat-card class="epic-card" (click)="openEpic(epic)" [style.border-left-color]="epic.color || '#64748b'">
          <div class="epic-card-head">
            <span class="epic-key">{{ epic.epicKey }}</span>
            <span class="swatch" [style.background]="epic.color || '#64748b'"></span>
          </div>
          <h2>{{ epic.epicSummary }}</h2>
          <mat-progress-bar mode="determinate" [value]="epic.percentComplete"></mat-progress-bar>
          <div class="epic-meta">
            <span>{{ epic.doneChildren }}/{{ epic.totalChildren }} done ({{ epic.percentComplete }}%)</span>
            <span matTooltip="Story points">{{ epic.storyPointsDone || 0 }}/{{ epic.storyPointsCommitted || 0 }} SP</span>
          </div>
          @if (epic.overdueCount) {
            <div class="overdue">{{ epic.overdueCount }} overdue</div>
          }
          <div class="dates" *ngIf="epic.startDate || epic.dueDate">
            {{ epic.startDate || '—' }} → {{ epic.dueDate || '—' }}
          </div>
        </mat-card>
      } @empty {
        <p class="muted empty">No epics in this project.</p>
      }
    </div>
  }
</div>
